import React from "react";
import { Link } from "react-router-dom";
import { FiArrowRight, FiCheckCircle } from "react-icons/fi";
import { uniformCategories } from "../data/productsData";
import "./CategoryLanding.css";

export default function Uniforms() {
  return (
    <div className="cat-landing">
      <section className="cat-hero">
        <div
          className="cat-hero__bg"
          style={{
            backgroundImage:
              "url('https://images.unsplash.com/photo-1555597673-b21d5c935865?auto=format&fit=crop&w=1920&q=80')",
          }}
        />
        <div className="cat-hero__overlay" />
        <div className="container cat-hero__content">
          <span className="section-label">Our Collections</span>
          <h1 className="cat-hero__title">
            Martial Arts <span>Uniforms</span>
          </h1>
          <p className="cat-hero__sub">
            Competition-grade Gis manufactured in . Choose your discipline below
            to explore the full product range.
          </p>
          <div className="cat-hero__pills">
            {[
              "Full Custom Branding",
              "OEM & Private Label",
              "Exporting Worldwide",
            ].map((p) => (
              <span key={p} className="cat-hero__pill">
                <FiCheckCircle size={13} />
                {p}
              </span>
            ))}
          </div>
        </div>
      </section>

      <section className="cat-sub-section">
        <div className="container">
          <div className="cat-sub-intro">
            <span className="section-label">Select Your Discipline</span>
            <h2 className="section-title">Choose a Uniform Category</h2>
            <div className="divider-gold" />
            <p className="section-subtitle">
              Each category contains multiple products with different fabric
              weights, GSM options and customization capabilities.
            </p>
          </div>
          <div className="cat-sub-grid">
            {uniformCategories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/uniforms/${cat.slug}`}
                className="cat-sub-card"
              >
                <div className="cat-sub-card__img">
                  <img src={cat.img} alt={cat.title} loading="lazy" />
                  <div className="cat-sub-card__img-overlay" />
                </div>
                <div className="cat-sub-card__body">
                  <div
                    className="cat-sub-card__tag"
                    style={{ background: cat.color }}
                  >
                    {cat.tagline}
                  </div>
                  <h3 className="cat-sub-card__title">{cat.title}</h3>
                  <p className="cat-sub-card__desc">{cat.desc}</p>
                  <div
                    className="cat-sub-card__cta"
                    style={{ color: cat.color }}
                  >
                    View All {cat.title} Products <FiArrowRight size={16} />
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <section className="cat-why">
        <div className="container cat-why__inner">
          <div className="cat-why__text">
            <span className="section-label">Why Choose Us</span>
            <h2 className="section-title" style={{ color: "var(--white)" }}>
              Built for Champions, Made for Scale
            </h2>
            <div className="divider-gold" />
            <p
              style={{
                color: "rgba(255,255,255,0.7)",
                lineHeight: 1.8,
                fontSize: "0.95rem",
              }}
            >
              Every uniform goes through 10 in-house departments — from fabric
              weaving and dyeing to cutting, stitching, printing, QC and export
              packing. We control every stage for consistent quality every time.
            </p>
          </div>
          <div className="cat-why__features">
            {[
              {
                label: "Fabric Options",
                value: "Pearl, Gold, Crystal, Diamond, Honey Comb, Chess Weave",
              },
              {
                label: "GSM Range",
                value: "350 GSM – 750 GSM depending on discipline",
              },
              {
                label: "Customization",
                value: "Color, embroidery, patches, labels, packaging",
              },
              { label: "MOQ", value: "Starts from 10 pcs per style per color" },
              { label: "Sample Time", value: "2–3 weeks" },
              { label: "Bulk Delivery", value: "4–6 weeks" },
            ].map((f) => (
              <div key={f.label} className="cat-feature">
                <span className="cat-feature__label">{f.label}</span>
                <span className="cat-feature__value">{f.value}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="cat-cta">
        <div className="container cat-cta__inner">
          <div>
            <h2>Need a Custom Uniform Quote?</h2>
            <p>
              Send us your design, quantity and size breakdown — we'll respond
              within 24 hours.
            </p>
          </div>
          <Link to="/contact" className="btn-primary">
            Request a Quote <FiArrowRight size={16} />
          </Link>
        </div>
      </section>
    </div>
  );
}
